import Axios from "../api/axios";
import config from "../../config";

const getHelp = () => {
  return Axios.get(`${config.BASE_URL}help`);
};

export default getHelp;
